module.exports = __webpack_public_path__ + "media/packs/radio-441e4097fdffa3a2544248862caddd8f.svg";